/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-tumor.reducer';

export const TreatmentTumorDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentTumorEntity = useAppSelector(state => state.treatmentTumor.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentTumorDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentTumor.detail.title">TreatmentTumor</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentTumor.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentTumorEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentTumor.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentTumorEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentTumor.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentTumorEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentTumor.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentTumorEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentTumor.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentTumorEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentTumor.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentTumorEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentTumor.tumor">Tumor</Translate>
          </dt>
          <dd>{treatmentTumorEntity.tumor ? treatmentTumorEntity.tumor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentTumor.regimen">Regimen</Translate>
          </dt>
          <dd>{treatmentTumorEntity.regimen ? treatmentTumorEntity.regimen.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-tumor" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-tumor/${treatmentTumorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentTumorDetail;
